import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import {
  AggspSubscriptionDetailsGQL,
  AggspSubscriptionDetailsQuery,
} from "../../../../apis/networkdashboard/graphql/graphql";
import { SubscriptionPageComponent } from "../../../../components/subscription-detail/subscription-page/subscription-page";
import { AggspSubscriptionDetails } from "../../types";
import { GenericSubscription } from "../generic-subscription";
import { AggspSubscriptionViewComponent } from "./aggsp-subscription-view";

@Component({
  selector: "aggsp-subscription",
  templateUrl: "aggsp-subscription.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AggspSubscriptionViewComponent, SubscriptionPageComponent],
})
export class AggspSubscriptionComponent extends GenericSubscription<
  AggspSubscriptionDetailsQuery,
  AggspSubscriptionDetails
> {
  protected query = inject(AggspSubscriptionDetailsGQL);

  protected onQuerySuccess(data: AggspSubscriptionDetailsQuery): AggspSubscriptionDetails {
    return data.aggspDetails;
  }
}
